import ApiService from './ApiService';

class CashInService {
  async performCashIn(payload = {}) {
    try {
      const response = await ApiService.call('/secured/perform_cash_in', 'POST', payload);

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }
}
export default new CashInService();
